module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.component_class
  }, [_c('transition', {
    attrs: {
      "name": "float-up"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_correct || _vm.is_error),
      expression: "is_correct || is_error"
    }],
    staticClass: "tip-wrapper"
  }, [(_vm.is_correct) ? _c('span', {
    staticClass: "correct-sign"
  }, [_c('Icon', {
    staticClass: "icon",
    attrs: {
      "name": "check",
      "size": 12,
      "color": "#4fae9b"
    }
  })], 1) : (_vm.is_error) ? _c('p', {
    staticClass: "tip"
  }, [_vm._v(" * " + _vm._s(_vm.self_tip))]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73f8656e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Input/components/InputTip.vue
// module id = 677
// module chunks = 0